import React, { FC, ReactNode } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

import css from './style.module.scss';

import Icon from '@sv-support-sdk/ui-components/src/components/Media/Icon';

interface IDropdownPanelProps {
  icon?: string;
  title?: ReactNode;
  subtitle?: string;
  showHint?: boolean;
  onClick?: () => void;
  id?: string;
  disabled?: boolean;
  link?: string;
}

const DropdownPanel: FC<IDropdownPanelProps> = ({
  icon,
  title,
  subtitle,
  showHint = false,
  onClick,
  id,
  disabled,
  link,
}) => {
  return (
    <Link
      className={classNames(css.search__dropdownButton, { [css.disabled]: disabled })}
      onClick={onClick}
      id={id}
      to={link || ''}
    >
      <span className={css.search__panel}>
        {icon && (
          <span className={css.search__panelIcon}>
            <Icon id={icon} />
          </span>
        )}
        <span className={css.search__panelContent}>
          <span className={css.search__panelTitle}>{title}</span>
          {subtitle && <span className={css.search__panelSubtitle}>{subtitle}</span>}
        </span>
        {showHint && <span className={css.search__panelHint}>Press ENTER</span>}
      </span>
    </Link>
  );
};

export default DropdownPanel;
